import * as React from 'react';
import { getPalette } from 'owa-theme';

export interface StyledHoverElementProps {
    /**
     * If set to true background color of child element
     * will be highlightedColor and on hover it will be
     * highlightedHoverColor
     */
    isHighlighted?: boolean;

    // background color property for selected element
    highlightedColor?: string;

    // background color property for selected element on hover
    highlightedHoverColor?: string;

    // background color property for element on hover
    hoverColor?: string;

    //hover callback
    onHoverCallback?: (isHoverState: boolean) => void;

    children?: React.ReactNode;
}

export interface StyledHoverElementState {
    isInHoverState: boolean;
}

/**
 * Wrapper to implement hover based on styles passed
 * ie. highlightedColor, highlightedHoverColor and hoverColor
 */
/**
 * Wrapper to implement hover based on styles passed
 * ie. highlightedColor, highlightedHoverColor and hoverColor
 */
export default function StyledHoverElement(props: StyledHoverElementProps) {
    props = {
        isHighlighted: false,
        ...props,
    };
    const [isInHoverState, setIsInHoverState] = React.useState<boolean>(false);
    const turnHoverOn = () => {
        setIsInHoverState(true);
        props.onHoverCallback?.(true);
    };
    const turnHoverOff = () => {
        setIsInHoverState(false);
        props.onHoverCallback?.(false);
    };
    /**
     * Create style for row based on state ie. selected, hover etc.
     */
    const getStyleForElement = (): React.CSSProperties => {
        const themeSymbols = getPalette();
        const {
            highlightedColor = themeSymbols.themeLighter,
            highlightedHoverColor = themeSymbols.themeLight,
            hoverColor = themeSymbols.neutralLighter,
            isHighlighted,
        } = props;
        if (isInHoverState && isHighlighted) {
            return {
                backgroundColor: highlightedHoverColor,
                cursor: 'pointer',
            };
        } else if (isHighlighted) {
            return {
                backgroundColor: highlightedColor,
            };
        } else if (isInHoverState) {
            return {
                backgroundColor: hoverColor,
                cursor: 'pointer',
            };
        } else {
            return {};
        }
    };
    return (
        <div style={getStyleForElement()} onMouseEnter={turnHoverOn} onMouseLeave={turnHoverOff}>
            {props.children}
        </div>
    );
}
